module.exports = __webpack_public_path__ + "img/table-delr-icon.a04bb6cc.svg";